// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cngEntity from './entities/cng.json';
import cngMenu from '../pages/cng/menu.json';
import cngFullForm from '../pages/cng/forms/full.json';
import cngContextForm from '../pages/cng/forms/context.json';
import cngMiniForm from '../pages/cng/forms/mini.json';
import cngLookupForm from '../pages/cng/forms/lookup.json';
import cngTableView from '../pages/cng/views/table.json';
import cngStagesView from '../pages/cng/views/stages.json';
import cngCardsView from '../pages/cng/views/cards.json';
import cngInlineView from '../pages/cng/views/inline.json';
import cngBacklogView from '../pages/cng/views/backlog.json';
import cngSplitView from '../pages/cng/views/split.json';
import cngCalendarView from '../pages/cng/views/calendar.json';
import cngDashboardView from '../pages/cng/views/dashboard.json';

/** Тип запису «Зустріч» зі сторінками пакета: меню, форми та подання з pages/cng/. */
export const cngDefinition: IRecordTypeDefinition = {
  ...cngEntity,
  views: assembleViewSet({
      table: cngTableView,
      stages: cngStagesView,
      cards: cngCardsView,
      inline: cngInlineView,
      backlog: cngBacklogView,
      split: cngSplitView,
      calendar: cngCalendarView,
      dashboard: cngDashboardView,
  }),
  form: cngFullForm,
  forms: { full: cngFullForm, context: cngContextForm, mini: cngMiniForm, lookup: cngLookupForm },
  menu: cngMenu,
} as IRecordTypeDefinition;
